import React, { useState } from "react";
import "./popup.scss";

const Popup = ({ isOpen, onClose, content }) => {
  return (
    <div className={`popup ${isOpen ? "open" : ""}`}>
      <div className="popup-content">
        {onClose && (
          <button className="close-button" onClick={onClose}>
            Close
          </button>
        )}
        {content}
      </div>
    </div>
  );
};

export default Popup;
